import { EntityRequest } from "../../entity/EntityRequest";

export class DtoRequestsPutRes extends EntityRequest {}
